(function () {
  function initReviews(root) {
    const track = root.querySelector('.etq-reviews__track');
    const slides = Array.from(root.querySelectorAll('.etq-reviews__slide'));
    const dotsWrap = root.querySelector('.etq-reviews__dots');
    const prevBtn = root.querySelector('.etq-reviews__arrow--prev');
    const nextBtn = root.querySelector('.etq-reviews__arrow--next');
    if (!track || slides.length === 0) return;

    let index = 0;

    function visibleCount() {
      return window.matchMedia('(max-width: 749px)').matches ? 1 : 3;
    }

    function maxIndex() {
      // one card at a time; stop when the last card is in view
      return Math.max(0, slides.length - visibleCount());
    }

    function go(i) {
      index = Math.max(0, Math.min(i, maxIndex()));
      const slide = slides[index];
      const offset = slide.offsetLeft - track.offsetLeft;
      track.scrollTo({ left: offset, behavior: 'smooth' });
      updateDots();
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      const count = maxIndex() + 1;
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'etq-reviews__dot';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', () => go(i));
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => go(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => go(index + 1));

    // sync dot state when user swipes the track directly
    let scrollTimer;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
        const approx = Math.round(track.scrollLeft / slideWidth);
        index = Math.max(0, Math.min(approx, maxIndex()));
        updateDots();
      }, 80);
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { buildDots(); go(index); }, 150);
    });

    buildDots();
  }

  function initAll() {
    document.querySelectorAll('[data-etq-reviews]').forEach(initReviews);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // re-init inside Shopify theme editor
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-etq-reviews]').forEach(initReviews);
  });
})();